/* odp-mdf-cart-readd v3 */
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = this.resolveCartUi();
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      resolveCartUi() {
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      }

      cartDrawerSectionIds() {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return null;
        if (typeof drawer.getSectionsToRender === 'function') {
          return drawer.getSectionsToRender().map((section) => section.id).join(',');
        }
        return 'cart-drawer,cart-icon-bubble';
      }

      async fetchCartDrawerSections() {
        const drawer = document.querySelector('cart-drawer');
        const ids = this.cartDrawerSectionIds();
        if (!drawer || !ids) return null;
        const root = window.Shopify?.routes?.root || '/';
        const sectionsUrl =
          typeof window.odysseyCartDrawerSectionsUrl === 'function'
            ? window.odysseyCartDrawerSectionsUrl()
            : window.routes?.cart_url || '/cart';
        const url =
          root +
          '?sections=' +
          encodeURIComponent(ids) +
          '&sections_url=' +
          encodeURIComponent(sectionsUrl);
        const res = await fetch(url);
        if (!res.ok) return null;
        return res.json();
      }

      applyCartDrawerSections(drawer, sections) {
        if (!drawer || !sections?.['cart-drawer']) return false;

        if (typeof window.odysseyPatchCartDrawerFromSectionHtml === 'function') {
          window.odysseyPatchCartDrawerFromSectionHtml(sections['cart-drawer'], { fullEmpty: false });
        } else {
          const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          const importedDrawer = doc.querySelector('#CartDrawer');
          const liveDrawer = drawer.querySelector('#CartDrawer');
          if (!importedDrawer || !liveDrawer) return false;
          liveDrawer.innerHTML = importedDrawer.innerHTML;
        }

        const bubbleHtml = sections['cart-icon-bubble'];
        const bubbleEl = document.getElementById('cart-icon-bubble');
        if (bubbleHtml && bubbleEl) {
          const bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          const bubbleSection =
            bubbleDoc.querySelector('.shopify-section') ||
            bubbleDoc.querySelector('[id^="shopify-section-cart-icon"]');
          if (bubbleSection) bubbleEl.innerHTML = bubbleSection.innerHTML;
        }

        const domLines =
          drawer.querySelectorAll('#CartDrawer-CartItems .cart-item, #CartDrawer-CartItems tr.cart-item').length >
          0;
        if (domLines) {
          drawer.querySelector('.drawer__inner-empty')?.remove();
          drawer.classList.remove('is-empty');
          drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
          drawer.querySelector('.drawer__inner')?.classList.toggle('is-empty', false);
        }

        const overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) {
          overlay.replaceWith(overlay.cloneNode(true));
          drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
        }
        return true;
      }

      async openCartDrawerAfterAdd(response) {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        window.odysseyMarkCartDrawerFullyRefreshed?.();

        if (window.OdysseyPdpAddons?.openCartDrawerAfterAdd) {
          try {
            await window.OdysseyPdpAddons.openCartDrawerAfterAdd(drawer, response);
            return;
          } catch (addonDrawerError) {
            console.warn(addonDrawerError);
          }
        }

        const merged = { ...(response || {}) };
        if (merged.sections?.['cart-drawer']) {
          this.applyCartDrawerSections(drawer, merged.sections);
        }
        window.odysseyPrepareCartDrawerQuickOpen?.(merged);
        drawer.open();
        void (async () => {
          let sections = merged.sections;
          if (!sections?.['cart-drawer']) {
            for (let attempt = 0; attempt < 3; attempt += 1) {
              sections = await this.fetchCartDrawerSections();
              if (sections?.['cart-drawer']) break;
              await new Promise((resolve) => window.setTimeout(resolve, 80 * (attempt + 1)));
            }
          }
          if (sections) this.applyCartDrawerSections(drawer, sections);
          if (typeof window.odysseyEnsureCartDrawerReadyAfterOpen === 'function') {
            await window.odysseyEnsureCartDrawerReadyAfterOpen(merged);
          }
          window.odysseyCartDrawerAddonsScanAfterOpen?.();
        })();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.cart = this.resolveCartUi() || this.cart;
        if (
          this.submitButton.getAttribute('aria-disabled') === 'true' &&
          this.submitButton.classList.contains('loading')
        ) {
          return;
        }

        const isMdfPdp = window.OdysseyPickCartSync?.isMdfTableTopPdp?.() === true;
        const productUrl = document.querySelector('product-info')?.dataset?.url || '';
        const isDualMotorPdp =
          /dual-motor-standing-desk/.test(productUrl) ||
          /\/products\/dual-motor-standing-desk(\/|$)/.test(window.location.pathname);
        if (
          isMdfPdp &&
          window.OdysseyPickCartSync?.mdfHasAccessorySelections?.() !== true
        ) {
          void window.OdysseyPickCartSync?.runMdfAjaxCartAdd?.(this.form);
          return;
        }

        const mdfLinkInput =
          this.form?.querySelector('[data-odp-mdf-finish-link-input]') ||
          document.querySelector('[data-odp-mdf-finish-link-input]');
        if (isMdfPdp || isDualMotorPdp) {
          window.OdysseyTableTopCustomize?.commitMdfLinkForCartAdd?.(this.form);
        }

        if (isDualMotorPdp && window.OdysseyDualMotorPackage?.isFrameOnly?.()) {
          const frameValidation = window.OdysseyDualMotorPackage.validateFrameOnlyCartAdd?.(this.form);
          if (frameValidation && !frameValidation.ok) {
            this.handleErrorMessage(frameValidation.message);
            return;
          }
        }

        if (isMdfPdp && window.OdysseyPickCartSync?.isMdfCartReady?.(this.form) === false) {
          window.OdysseyPickCartSync?.syncMdfAddToCartButtonState?.(this.form);
          const validation = window.OdysseyTableTopCustomize?.validateCartAdd?.(this.form);
          if (validation && !validation.ok) {
            this.handleErrorMessage(validation.message);
          }
          return;
        }

        if (this.submitButton.disabled && !isMdfPdp) return;
        if (isMdfPdp && this.submitButton.disabled) {
          this.submitButton.disabled = false;
        }

        this.submitButton.removeAttribute('aria-disabled');

        window.OdysseyPickCartSync?.ensureMdfReadyForCartAdd?.(this.form);

        let validation = window.OdysseyTableTopCustomize?.validateCartAdd?.(this.form);
        if (validation && !validation.ok) {
          window.OdysseyPickCartSync?.ensureMdfReadyForCartAdd?.(this.form);
          validation = window.OdysseyTableTopCustomize?.validateCartAdd?.(this.form);
        }
        if (validation && !validation.ok) {
          this.handleErrorMessage(validation.message);
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.setSubmitSpinnerHidden(false);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let materializedLineProps = null;
        try {
          if (window.OdysseyPickCartSync?.materializeLineItemProperties) {
            materializedLineProps = window.OdysseyPickCartSync.materializeLineItemProperties(this.form);
          } else {
            const prepared = window.OdysseyPickCartSync?.prepareCartAdd
              ? window.OdysseyPickCartSync.prepareCartAdd(this.form)
              : window.OdysseyTableTopCustomize?.prepareCartAdd?.(this.form);
            if (prepared === false) {
              const retryValidation = window.OdysseyTableTopCustomize?.validateCartAdd?.(this.form);
              throw new Error(retryValidation?.message || 'Could not add to cart.');
            }
          }
        } catch (materializeError) {
          this.handleErrorMessage(materializeError?.message || 'Could not add to cart.');
          this.submitButton.classList.remove('loading');
          this.setSubmitSpinnerHidden(true);
          this.submitButton.removeAttribute('aria-disabled');
          return;
        }

        window.OdysseyPickCartSync?.stabilizeMdfCartVariantId?.(this.form);
        const variantId = this.form.querySelector('[name="id"]')?.value;
        if (!variantId) {
          this.handleErrorMessage('Could not add to cart — missing product variant.');
          window.OdysseyPickCartSync?.restoreAssociatedPropertyInputs?.(this.form);
          this.submitButton.classList.remove('loading');
          this.setSubmitSpinnerHidden(true);
          this.submitButton.removeAttribute('aria-disabled');
          return;
        }

        const useOdpJsonAdd = !!window.OdysseyPickCartSync?.gatherLineItemProperties;
        const cartAddFailed = (response) => {
          if (response == null || typeof response !== 'object') return false;
          if (Array.isArray(response.items) && response.items.length > 0) return false;
          if (response.id != null && response.status == null) return false;
          return response.status != null && Number(response.status) >= 400;
        };

        const finishSubmit = (response, variantIdForEvent) => {
          if (cartAddFailed(response)) {
            this.error = true;
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: variantIdForEvent,
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description || response.message);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            return;
          }

          const cartDrawer = document.querySelector('cart-drawer');
          if (!cartDrawer && !this.cart) {
            window.location.assign(window.routes.cart_url);
            return;
          }

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantIdForEvent,
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          const openDrawer = async () => {
            try {
              await this.openCartDrawerAfterAdd(response);
            } catch (drawerError) {
              console.error(drawerError);
              this.handleErrorMessage(
                drawerError?.message ||
                  'Added to cart, but the cart drawer could not open. Use the cart icon to view your items.'
              );
            }
          };

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  CartPerformance.measure('add:paint-updated-sections', () => {
                    void openDrawer();
                  });
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            CartPerformance.measure('add:paint-updated-sections', () => {
              void openDrawer();
            });
          }
        };

        const finalizeSubmit = () => {
          window.OdysseyPickCartSync?.restoreAssociatedPropertyInputs?.(this.form);
          window.OdysseyPickCartSync?.syncMdfAddToCartButtonState?.(this.form);
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty') && !this.error) {
            this.cart.classList.remove('is-empty');
          }
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.setSubmitSpinnerHidden(true);
          CartPerformance.measureFromEvent('add:user-action', evt);
        };

        const cartDrawerForAdd = document.querySelector('cart-drawer');
        const cartUiForAdd = cartDrawerForAdd || this.cart;
        if (cartUiForAdd) {
          cartUiForAdd.setActiveElement(document.activeElement);
        }

        if (useOdpJsonAdd) {
          const lineProps =
            materializedLineProps && Object.keys(materializedLineProps).length > 0
              ? materializedLineProps
              : window.OdysseyPickCartSync.gatherLineItemProperties(this.form);
          const quantity =
            window.OdysseyPickCartSync?.readCartAddQuantity?.(this.form) ??
            Number(
              this.form.elements?.namedItem?.('quantity')?.value ||
                this.form.querySelector('[name="quantity"]')?.value ||
                1
            );
          const body = {
            items: [
              {
                id: Number(variantId),
                quantity,
                properties: lineProps,
              },
            ],
          };
          const sectionIds = this.cartDrawerSectionIds();
          if (sectionIds) {
            body.sections = sectionIds;
            body.sections_url =
              typeof window.odysseyCartDrawerSectionsUrl === 'function'
                ? window.odysseyCartDrawerSectionsUrl()
                : window.routes?.cart_url || '/cart';
          }

          fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((response) => finishSubmit(response, String(variantId)))
            .catch((e) => {
              console.error(e);
              this.error = true;
              this.handleErrorMessage('Could not add to cart. Please try again.');
            })
            .finally(finalizeSubmit);
          return;
        }

        const formData = new FormData(this.form);
        if (window.OdysseyPickCartSync?.applyPropertiesToFormData) {
          window.OdysseyPickCartSync.applyPropertiesToFormData(formData, this.form);
        } else if (window.OdysseyTableTopCustomize?.applyToFormData) {
          window.OdysseyTableTopCustomize.applyToFormData(formData, this.form);
        }
        const sectionIds = this.cartDrawerSectionIds();
        if (sectionIds) {
          formData.append('sections', sectionIds);
          formData.append(
            'sections_url',
            typeof window.odysseyCartDrawerSectionsUrl === 'function'
              ? window.odysseyCartDrawerSectionsUrl()
              : window.routes?.cart_url || '/cart'
          );
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => finishSubmit(response, formData.get('id')))
          .catch((e) => {
            console.error(e);
            this.error = true;
            this.handleErrorMessage('Could not add to cart. Please try again.');
          })
          .finally(finalizeSubmit);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      getSubmitSpinner() {
        return this.submitButton?.querySelector('.loading__spinner');
      }

      setSubmitSpinnerHidden(hidden) {
        const spinner = this.getSubmitSpinner();
        if (spinner) spinner.classList.toggle('hidden', hidden);
      }
    }
  );
}
